import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit-element/lit-element.js';
import { ifDefined } from '../../node_modules/lit-html/directives/if-defined.js';
import { Slotify } from '../../node_modules/@eightshapes/slotify/src/slotify.js';
import customElement from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/decorators/custom-element.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';
import { html } from '../../node_modules/lit-html/lit-html.js';
import { property } from '../../node_modules/lit-element/lib/decorators.js';

var VerticalAlign;
(function (VerticalAlign) {
    VerticalAlign["top"] = "top";
    VerticalAlign["center"] = "center";
    VerticalAlign["bottom"] = "bottom";
})(VerticalAlign || (VerticalAlign = {}));
var DEFAULT_DENSE = false;
var DEFAULT_FIXED_WIDTH = false;
var DEFAULT_INLINE = Inline.never;
var DEFAULT_VERTICAL_ALIGN = VerticalAlign.top;
/**
 * Providence Field Group component.
 * @see {@link https://providence.fmr.com/components/field-group/field-group.html|Field Group documentation}
 */
var CustomElementMixin = customElement({
    name: 'field-group',
    namespace: 'pvd',
});
var PvdFieldGroup = /** @class */ (function (_super) {
    __extends(PvdFieldGroup, _super);
    function PvdFieldGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDense = DEFAULT_DENSE;
        _this.pvdFixedWidth = DEFAULT_FIXED_WIDTH;
        _this.pvdInline = DEFAULT_INLINE;
        _this.pvdVerticalAlign = DEFAULT_VERTICAL_ALIGN;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdFieldGroup.prototype, "fieldGroupRole", {
        // #endregion
        // #region private methods
        get: function () {
            return this.pvdAriaLabel || this.pvdAriaLabelledby ? 'group' : undefined;
        },
        enumerable: true,
        configurable: true
    });
    // #endregion
    // #region LitElement lifecycles
    PvdFieldGroup.prototype.renderGroupLabel = function () {
        return this.isSlotUsed('group-label')
            ? html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          <div class=\"pvd-field-group__group-label\">\n            <s-slot name=\"group-label\"></s-slot>\n          </div>\n        "], ["\n          <div class=\"pvd-field-group__group-label\">\n            <s-slot name=\"group-label\"></s-slot>\n          </div>\n        "]))) : html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<s-slot name=\"group-label\"></s-slot>"], ["<s-slot name=\"group-label\"></s-slot>"])));
    };
    PvdFieldGroup.prototype.render = function () {
        var classMap = {
            // @ts-ignore
            default: this.constructor.namespace + "-field-group-root",
            modifierPrefix: 'pvd-field-group',
            modifiers: [
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
                {
                    condition: true,
                    className: this.pvdFixedWidth ? 'fixed-width' : 'full-width',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: 'inline',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: "inline-" + this.pvdInline,
                },
                {
                    condition: this.pvdVerticalAlign !== undefined,
                    className: "vertical-align-" + this.pvdVerticalAlign,
                },
            ],
        };
        return html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n        <div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-field-group__field-group\"\n          role=\"", "\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        ", "\n        <div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-field-group__field-group\"\n          role=\"", "\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "])), getClassName(classMap), this.renderGroupLabel(), ifDefined(this.pvdAriaDescribedby), ifDefined(this.pvdAriaLabel), ifDefined(this.pvdAriaLabelledby), ifDefined(this.fieldGroupRole));
    };
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaLabel", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaLabelledby", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-dense' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'))),
        __metadata("design:type", Boolean)
    ], PvdFieldGroup.prototype, "pvdDense", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-fixed-width' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-fixed-width'))),
        __metadata("design:type", Boolean)
    ], PvdFieldGroup.prototype, "pvdFixedWidth", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-inline' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdInline", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-vertical-align' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdVerticalAlign", void 0);
    return PvdFieldGroup;
}(CustomElementMixin(Slotify(PvdSlotifyBaseComponent))));
var templateObject_1, templateObject_2, templateObject_3;

export { DEFAULT_DENSE, DEFAULT_FIXED_WIDTH, DEFAULT_INLINE, DEFAULT_VERTICAL_ALIGN, PvdFieldGroup, VerticalAlign };
